import { render, staticRenderFns } from "./routerLab.vue?vue&type=template&id=6893eea2&scoped=true"
import script from "./routerLab.vue?vue&type=script&lang=js"
export * from "./routerLab.vue?vue&type=script&lang=js"
import style0 from "./routerLab.vue?vue&type=style&index=0&id=6893eea2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6893eea2",
  null
  
)

export default component.exports